import { all } from 'redux-saga/effects';

import analyticsSagas from './analytics/sagas';
import workflowSagas from './workflow/sagas';
import pageSagas from './page/sagas';
import sessionSagas from './session/sagas';
import groupSagas from './groups/sagas';
import fieldSagas from './fields/sagas';
import themeSagas from './theme/sagas';
import plaidSagas from './plaid/sagas';
import dialogSagas from './dialogs/sagas';
import homeSagas from './home/sagas';

const sagasToRun = [
  ...pageSagas,
  ...workflowSagas,
  ...sessionSagas,
  ...groupSagas,
  ...fieldSagas,
  ...themeSagas,
  ...plaidSagas,
  ...dialogSagas,
  ...homeSagas,
];

if (process.env.REACT_APP_ENV !== 'dev' && process.env.REACT_APP_ENV !== 'test') {
  sagasToRun.push(...analyticsSagas);
}

export default function* sagas() {
  yield all(sagasToRun);
}
